import {useState, useEffect} from "react"
import { apiClient } from "../services/apiClient"

export const useLanguages = () => {
  const [languages, setLanguages] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const data = await apiClient.get("/language/", { params: { firm: 3 } })
        const filteredLanguages = data.filter(
          (language) => language.name === "TR" || language.name === "EN"
        )

        setLanguages(filteredLanguages)
      } catch (err) {
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }

    fetchLanguages()
  }, [])

  return {languages, loading, error}
}
